module.exports = __webpack_public_path__ + "img/interakt1.1df74c3a.png";